import React from 'react';
import Header from '../../views/Header';

function GuessGame(props) {
    return (
        <div>
            <Header/>
            <h2>Guess game is coming soon!</h2>
        </div>
    );
}

export default GuessGame;